import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';

const SurveyEmptyList = ({children}) => (
    <div className="survey-empty-list-box">
        <div className="d-flex flex-column text-center">
            <h1>
                <FormattedMessage {...messages.surveys.list.empty} />
            </h1>
            <div>
                {children}
            </div>
        </div>
    </div>
);

export default SurveyEmptyList;
